import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "container-login100 p-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_simple_screen = _resolveComponent("g-simple-screen");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_g_simple_screen, null, {
            default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
        })
    ]));
}
